<template>
	<div>
		<section>
			<h2 class="font-serif color-y">What is DCP?</h2>
			<p>Deadbolt Community Patch (DCP) is a massive update to the codebase of <a target="_blank" href="https://store.steampowered.com/app/394970/DEADBOLT/">DEADBOLT</a>, a 2016 game by Hopoo, the dev behind Risk of Rain.</p>
			<p>Each feature is individually enabled, so you have complete control over the changes you experience.</p>
			<p>See some of the features in action in <a target="_blank" href="https://www.youtube.com/watch?v=19DdnqxzR-0&list=PLDIGssVhQPHbQts9HrB_VHM2zE_gt_Dtw">this YouTube playlist</a>.</p>
			<p>Alpha build downloads are available on the <a target="_blank" href="https://discord.gg/nw3Ad2c">Deadbolt Discord</a>.</p>
			<p class="color-r">DCP is currently in alpha. Some features are WIP or unreleased. Expect bugs.</p>
		</section>

		<section>
			<h2 class="font-serif color-y">New Game Features</h2>
			<ul>
				<li>Improved Load Game Menu: Shows your death and souls count</li>
				<li>Improved Workshop pause menu: Quick restart & quit to the Custom Levels screen</li>
				<li>Improved Charon: Weapon stats on hover, colours show if you can afford weapons or not</li>
				<li>Quick restart hotkey on level completion</li>
				<li>Visual indicators show you who will hear your gunshot</li>
				<li>Change the music for the main menu and end credits</li>
				<li>Hold shift to walk - with custom sprite animations by <a target="_blank" href="https://steamcommunity.com/id/Nintee/myworkshopfiles/?appid=394970">Nintee</a></li>
				<li>Customise weapons with a huge JSON</li>
				<li>Option to skip cutscenes in campaign levels</li>
				<li>See mission par times (warning: most are probably unatainable!)</li>
				<!-- <li>Pipe valves are green after activating</li> -->
				<!-- <li>Player-placed mine radius is green instead of red</li> -->
			</ul>
		</section>

		<section>
			<h2 class="font-serif color-y">Level Creation</h2>
			<ul>
				<li>Debug options for local maps: teleport, infinite ammo, access all weapons from the trunk, and more</li>
				<li>Set your character and weapons</li>
				<li>Control player abilities (block vents, weapon pickups and more)</li>
				<li>Weather control</li>
				<li>Level configs can be published with your maps</li>
				<li>Unsupported objects no longer cause a crash (eg. oRef1), and now show a tip with the object name</li>
			</ul>
		</section>

		<section>
			<h2 class="font-serif color-y">WIP Features</h2>
			<ul>
				<li>Publish entire custom campaigns to the Workshop (<a target="_blank" href="https://www.youtube.com/watch?v=qMXxaFbH5BQ">video</a>)</li>
				<li>Rolling! Dive across the floor for extra speed</li>
				<li>2 uncut weapons: Burst Pistol & Sickle</li>
				<li>So many planned features. Join the <a target="_blank" href="https://discord.gg/nw3Ad2c">Deadbolt Discord</a> for early previews</li>
			</ul>
		</section>

		<section class="download">
			<h2 class="font-serif color-y">Download</h2>
			<p><a target="_blank" href="/files/DCP_ALPHA_1.5.0.zip">DCP ALPHA 1.5.0</a></p>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'AboutContent',
	}
</script>
